import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "ActAccessModalStepReviewAndConfirm" }
const _hoisted_2 = {
  key: 0,
  class: "ActAccessContentSubSection"
}
const _hoisted_3 = { class: "ActReviewAndConfirmRow" }
const _hoisted_4 = { class: "ActReviewAndConfirmDetails" }
const _hoisted_5 = { class: "ActReviewAndConfirmRow" }
const _hoisted_6 = { class: "ActReviewAndConfirmTitle" }
const _hoisted_7 = { class: "ActReviewAndConfirmNote" }
const _hoisted_8 = { class: "ActReviewAndConfirmDetails" }
const _hoisted_9 = { class: "ActReviewAndConfirmRow" }
const _hoisted_10 = { class: "ActReviewAndConfirmTitle" }
const _hoisted_11 = { class: "ActReviewAndConfirmNote" }
const _hoisted_12 = { class: "ActReviewAndConfirmDetails" }
const _hoisted_13 = { class: "ActReviewAndConfirmRow" }
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Review and Confirm", -1 /* CACHED */)),
    (_ctx.relevantActAccessEntry)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "ActReviewAndConfirmTitle" }, "CRM Project", -1 /* CACHED */)),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.relevantActAccessEntry.projectName) + " (#" + _toDisplayString(_ctx.relevantActAccessEntry.projectNumber) + ") ", 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, [
              _cache[1] || (_cache[1] = _createTextVNode(" Users ", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.actUsersToAdd.length) + " added ", 1 /* TEXT */)
            ]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.actUsersToAddAsString), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h4", _hoisted_10, [
              _cache[2] || (_cache[2] = _createTextVNode(" Dashboards ", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.actDashboardsToAdd.length) + " selected ", 1 /* TEXT */)
            ]),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.actDashboardsToAddAsString), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "ActReviewAndConfirmTitle" }, "Access Period", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actDashboardsToShowDatesFor, (dashboard) => {
              return (_openBlock(), _createElementBlock("div", {
                key: dashboard.productNumber,
                class: "ActReviewAndConfirmAccessPeriodRow ActReviewAndConfirmDetails"
              }, [
                (!_ctx.sameDatesPerDashboard)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(dashboard.productName), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.transformDateObjectToUTCDateString(dashboard.productStartDate)) + " - " + _toDisplayString(_ctx.transformDateObjectToUTCDateString(dashboard.productEndDate)), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}